export const eulerSwapAddresses = {
  eulerSwapV1Factory: "0x6A72160963a562f21387B166aF31a92D154106fb",
  eulerSwapV1Implementation: "0xDFfaC13fC142Fc1d8E55226dB9c98f4b66371a3c",
  eulerSwapV1Periphery: "0xAF596563109C753b9c5e73DD596DD4bB247964cA",
} as const
